import { isEqual } from 'lodash';
import { useEffect, useState } from 'react';
export default function useResetOnDeps(dependencies, onChange, defaultValue, enableReset = true) {
    const [deps, setDeps] = useState(dependencies);
    useEffect(() => {
        if (enableReset && !isEqual(dependencies, deps)) {
            onChange && onChange(defaultValue);
            setDeps(dependencies);
        }
    }, [enableReset, defaultValue, dependencies, deps, setDeps, onChange]);
}
